<template>
  <v-toolbar app color="white">
    <v-tooltip bottom>
      <template v-slot:activator="{ on }">
        <v-btn icon outline color="primary" v-on="on" @click="onGoBackClick">
          <v-icon>arrow_back</v-icon>
        </v-btn>
      </template>
      {{ $t('go-back-btn') }}
    </v-tooltip>
    <v-toolbar-title>{{ name }}</v-toolbar-title>
  </v-toolbar>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      required: true
    }
  },
  methods: {
    onGoBackClick: function() {
      this.$router.go(-1)
    }
  }
}
</script>
